import {Injectable} from '@angular/core';

@Injectable()
export class ConfigurationProperties {

  private _pingfederateLoginUrl: string;
  private _termsAndConditionsUrl: string;
  private _faqUrl: string;
  private _contactUsUrl: string;
  private _mixPanelToken: string;
  private _riskAssessmentProfilingUrl: string;
  private _featureFlagCompanyValidation: boolean;

  get pingfederateLoginUrl(): string {
    return this._pingfederateLoginUrl;
  }

  set pingfederateLoginUrl(value: string) {
    this._pingfederateLoginUrl = value;
  }

  get termsAndConditionsUrl(): string {
    return this._termsAndConditionsUrl;
  }

  set termsAndConditionsUrl(value: string) {
    this._termsAndConditionsUrl = value;
  }

  get faqUrl(): string {
    return this._faqUrl;
  }

  set faqUrl(value: string) {
    this._faqUrl = value;
  }

  get contactUsUrl(): string {
    return this._contactUsUrl;
  }

  set contactUsUrl(value: string) {
    this._contactUsUrl = value;
  }

  get mixPanelToken(): string {
    return this._mixPanelToken;
  }

  set mixPanelToken(value: string) {
    this._mixPanelToken = value;
  }

  get riskAssessmentProfilingUrl(): string {
    return this._riskAssessmentProfilingUrl;
  }

  set riskAssessmentProfilingUrl(value: string) {
    this._riskAssessmentProfilingUrl = value;
  }

  get featureFlagCompanyValidation(): boolean {
    return this._featureFlagCompanyValidation;
  }

  set featureFlagCompanyValidation(value: boolean) {
    this._featureFlagCompanyValidation = value;
  }
}
